<router-outlet name="retroalimentacionalumno"></router-outlet>
<mat-tab-group (selectedIndexChange)="onChangeTab($event)">

    <mat-tab label="METAS">
        <ng-container>
            <unidad-etapas-metas [_metas]="unidad.metas" [categorias]="categorias" [unidadID]="unidad.id"
                [areas]="unidad.areas">
            </unidad-etapas-metas>
        </ng-container>

        <!-- 
        <ng-container *ngIf="unidad">
            <div class="unidad-metas-container">
                <button mat-icon-button (click)="showMetasReferencia = !showMetasReferencia"
                        *ngIf="!showMetasReferencia" matTooltip="Mostrar metas de referencia">
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <section class="metas-referencia" *ngIf="showMetasReferencia">
                    <div class="flex-wrap">
                        <h3 class="mat-h2">Mapa curricular
                            <small>Metas de referencia para la unidad</small>
                        </h3>
                        <span class="spacer"></span>
                        <button mat-icon-button (click)="showMetasReferencia = !showMetasReferencia"
                                matTooltip="Ocultar metas de referencia">
                            <mat-icon>chevron_left</mat-icon>
                        </button>
                    </div>
                    <p *ngIf="(metas | categoriaFilter: metasRCategorias).length == 0" class="empty">Sin metas
                        asociadas</p>
                    <ul *ngIf="showMetasReferencia" style="margin-top: 0">
                        <ng-container *ngFor="let metaReferencia of metas | categoriaFilter: metasRCategorias">
                            <li [attr.data-meta-id]="metaReferencia.id">
                                <unidad-meta [metaUnidad]="metaReferencia"
                                             [categorias]="categorias"
                                             [isFamilia]="true"></unidad-meta>
                            </li>
                        </ng-container>
                    </ul>
                </section>
                <section class="metas-unidad">
                    <div class="categoria">
                        <div>
                            <div>
                                <h3 class="mat-h2">
                                    Metas de transferencia
                                    <small>Los estudiantes podrán usar independientemente su aprendizaje para...</small>
                                </h3>
                                <p *ngIf="(metas | categoriaFilter: [12]).length == 0" class="empty">Sin metas
                                    asociadas</p>
                            </div>
                            <ul>
                                <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [12]">
                                    <li [attr.data-meta-id]="metaUnidad.id">
                                        <unidad-meta [metaUnidad]="metaUnidad"
                                                     [isFamilia]="true"></unidad-meta>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                    <div class="categoria">
                        <h3 class="mat-h2">
                            Metas de comprensión
                        </h3>
                        <div>
                            <div>
                                <h4 class="mat-h4">Comprensiones
                                    <small>Los estudiantes comprenderán que...</small>
                                </h4>
                                <p *ngIf="(metas | categoriaFilter: [13]).length == 0" class="empty">Sin metas
                                    asociadas</p>
                            </div>
                            <ul>
                                <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [13]">
                                    <li [attr.data-meta-id]="metaUnidad.id">
                                        <unidad-meta [metaUnidad]="metaUnidad"
                                                     [isFamilia]="true"></unidad-meta>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <h4 class="mat-h4">Preguntas esenciales
                                    <small>Los estudiantes seguirán considerando...</small>
                                </h4>
                                <p *ngIf="(metas | categoriaFilter: [14]).length == 0" class="empty">Sin metas
                                    asociadas</p>
                            </div>
                            <ul>
                                <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [14]">
                                    <li [attr.data-meta-id]="metaUnidad.id">
                                        <unidad-meta [metaUnidad]="metaUnidad"
                                                     [isFamilia]="true"></unidad-meta>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                    <div class="categoria">
                        <h3 class="mat-h2" id="test">
                            Metas de adquisición
                        </h3>
                        <div>
                            <div>
                                <h4 class="mat-h4">Conocimientos
                                    <small>Los estudiantes conocerán...</small>
                                </h4>
                                <p *ngIf="(metas | categoriaFilter: [16]).length == 0" class="empty">Sin metas
                                    asociadas</p>
                            </div>
                            <ul>
                                <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [16]">
                                    <li [attr.data-meta-id]="metaUnidad.id">
                                        <unidad-meta [metaUnidad]="metaUnidad"
                                                     [isFamilia]="true"></unidad-meta>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <h4 class="mat-h4">Habilidades
                                    <small>Los estudiantes serán capaces de...</small>
                                </h4>
                                <p *ngIf="(metas | categoriaFilter: [17]).length == 0" class="empty">Sin metas
                                    asociadas</p>
                            </div>
                            <ul>
                                <ng-container *ngFor="let metaUnidad of metas | categoriaFilter: [17]">
                                    <li [attr.data-meta-id]="metaUnidad.id">
                                        <unidad-meta [metaUnidad]="metaUnidad"
                                                     [isFamilia]="true"></unidad-meta>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </section>
            </div>
        </ng-container>
         -->
    </mat-tab>

    <mat-tab label="EVIDENCIAS" *ngIf="showEvidencias">
        <ng-container *ngIf="eventoCategorias">
            <unidad-etapas-evidencias 
            [alumnoId]="alumnoId"
            [_evidencias]="unidad.eventos"
            [unidadID]="unidad.id"
            [materias]="unidad.materias"
            [isFamilia]="true"
            [tiposEvidencias]="eventoCategorias">
            </unidad-etapas-evidencias>
        </ng-container>
    </mat-tab>

    <mat-tab label="PROFILE">
        <ng-container *ngIf="unidad">
            <rubrica-unidad [unidadID]="unidad.id" [isFamilia]="true"></rubrica-unidad>
        </ng-container>
    </mat-tab>

</mat-tab-group>